import React, { useState, useEffect } from "react";
import { registerUser } from "../../redux/user-redux/userStore";
import { useHistory } from "react-router-dom";
import {
  FormContainer,
  Container,
  H2,
  Form,
  Button,
  ProgressBtn,
} from "./RegisterStyle";
import SideComponent from "../../components/Commons/Side/SideComponent";
import { StepOne, StepTwo, StepThree } from "./RegisterFields";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Error from "../../components/Commons/userUtil/Error";

const RegisterForm = () => {
  const [values, setValues] = useState({
    first_name: "",
    last_name: "",
    email: "",
    stage_name: "",
    phone_number: "",
    biography: "",
    date_of_birth: "",
    confirm_password: "",
    password: "",
  });
  const [next, setNext] = useState({
    step1: true,
    step2: false,
    step3: false,
  });
  const [gender, setGender] = useState("");
  const [state, setYourState] = useState("");
  const [country, setCountry] = useState("");
  const [file, setFile] = useState({});
  const [close, setClose] = useState(false);

  const history = useHistory();

  const error = useSelector(({ useReducer: { errors } }) => errors);

  useEffect(() => {
    setClose(false);
  }, [error]);

  const dispatch = useDispatch();

  const handleInput = ({ currentTarget: { name, value } }) => {
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleGender = ({ target: { value } }) => {
    setGender(value);
  };
  const handleState = ({ target: { value } }) => {
    setYourState(value);
  };
  const handleCountry = ({ target: { value } }) => {
    setCountry(value);
  };
  const handleFile = ({ target: { files } }) => {
    setFile(files[0]);
  };

  const onsubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("first_name", values.first_name);
    formData.append("last_name", values.last_name);
    formData.append("stage_name", values.stage_name);
    formData.append("email", values.email);
    formData.append("phone_number", values.phone_number);
    formData.append("biography", values.biography);
    formData.append("date_of_birth", values.date_of_birth);
    formData.append("password", values.password);
    formData.append("confirm_password", values.confirm_password);
    formData.append("sex", gender);
    formData.append("state", state);
    formData.append("country", country);
    formData.append("profile_pic", file);
    // const data = {
    //   sex: gender,
    //   country,
    //   state,
    //   profile_pic: file,
    //   ...values,
    // };
    registerUser(dispatch, formData, history);
  };

  return (
    <Container>
      <FormContainer>
        <Form className='form'>
          <H2>Register Here</H2>
          {next.step1 && (
            <div>
              <StepOne handleInput={handleInput} values={values} />
              <ProgressBtn>
                <Button
                  onClick={() => {
                    if (
                      values.first_name &&
                      values.last_name &&
                      values.stage_name &&
                      values.email
                    ) {
                      setNext({ step1: false, step2: true });
                    } else {
                      setNext({ step1: true, step2: false });
                      toast.error("Please fill all fields");
                    }
                  }}
                >
                  Next
                </Button>
              </ProgressBtn>
            </div>
          )}

          {next.step2 && (
            <div>
              <StepTwo handleInput={handleInput} values={values} />
              <ProgressBtn>
                <Button onClick={() => setNext({ step3: false, step1: true })}>
                  Previous
                </Button>
                <Button
                  onClick={() => {
                    if (
                      values.phone_number &&
                      values.password &&
                      values.confirm_password &&
                      values.biography
                    ) {
                      setNext({ step3: true, step1: false });
                    } else {
                      setNext({ step1: false, step3: false, step2: true });
                      toast.error("Please fill all fields");
                    }
                  }}
                >
                  Next
                </Button>
              </ProgressBtn>
            </div>
          )}

          {next.step3 && (
            <div>
              <StepThree
                handleFile={handleFile}
                handleInput={handleInput}
                handleGender={handleGender}
                handleState={handleState}
                handleCountry={handleCountry}
                values={values}
              />
              <ProgressBtn>
                <Button
                  onClick={() => {
                    setNext({ step3: false, step2: true, step1: false });
                  }}
                >
                  Previous
                </Button>
                <Button onClick={onsubmit}>Register</Button>
              </ProgressBtn>
            </div>
          )}
          <Error error={error} close={close} setClose={setClose} />
        </Form>
        <SideComponent register='login' text='Login' />
      </FormContainer>
    </Container>
  );
};

export default RegisterForm;
